import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Routes from './Browse/routes';

const path = '/elasticsearch';

const routes = () => {
  return (
    <>
      <Switch>
        <Route path={Routes.path} component={Routes} />
      </Switch>
    </>
  );
};

routes.path = path;

export default routes;
